export default __webpack_public_path__ + "static/media/regression.b6bb1ddf.png";